import client from '../client';

const TRUSTPILOT_REVIEWS = {
  getExpertReviews(expertId, params) {
    return client.get(`/experts/${expertId}/reviews`, params)
  },
}

export default TRUSTPILOT_REVIEWS;
